import { parseCookies } from 'nookies'

function extractGaSessionId(measurementId) {
  const cookies = parseCookies()
  const sessionCookieName = `_ga_${measurementId}`
  const sessionCookie = cookies[sessionCookieName]

  if (!sessionCookie) {
    return null
  }

  // Check for new `$` format, GS2.1.s1746602632$o1$g1$t1746603143$j0$l0$h0 expected value 1746602632
  if (sessionCookie.includes('$')) {
    const match = sessionCookie.match(/\.s(\d+)\$/)
    return match ? match[1] : null
  }

  // Fallback: old `.`-separated format, GS1.1.1744101655.71.1.1744101680.0.0.0 expected value 1744101655
  const parts = sessionCookie.split('.')
  return parts.length >= 5 ? parts[2] : null
}

export { extractGaSessionId }
